<!--  -->
<template>
  <div :class="['newdrawLots', { inApp: $root.$data.isApp }]">
    <common-title titleName="压力测试" :bcColor="'#fff'" :zIndex="1000"> </common-title>
    <section class="section">
      <div class="drawWarrp">
        <p class="chou" @click="drawBtn">开始测试</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getRegisterSourceInfo,isminiLogin } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 抽奖按钮
    drawBtn() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'stresstest', 2, false);
        }else if(this.$root.whatEev === 'miniprogram'){
          let url = window.location.href;
          isminiLogin(url)
        } else {
          const { search } = window.location;
          const has = search !== '';
          const param = { has, redirect: '/stresstest' };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
      } else {
        setTimeout(() => {
          this.$router.push({path: '/answer'});
        }, 1000);
      }
    },

    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
  },
  created() {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.newdrawLots {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding-top: 100px;
  background: #DAFBC7;
  &.inApp {
    padding-top: 0;
  }
  .section {
    position: relative;
    width: 100%;
    height: 1174px;
    background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/stresstest/homebg.png)
      no-repeat;
    background-size: 100% 100%;
    .chou {
      position: absolute;
      bottom:30px;
      left:0;
      right: 0;
      margin:0 auto;
      width: 360px;
      height: 110px;
      line-height: 110px;
      background: #000000;
      border-radius: 55px;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      animation: breatheEffect 3s ease-in-out infinite;
    }
  }
  .share-btn {
    position: fixed;
    right: 36px;
    bottom: 20px;
    left: 36px;
    width: 678px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }

  @keyframes breatheEffect {
    0% {
      transform: scale(1);
    }

    25% {
      transform: scale(1.05);
    }

    50% {
      transform: scale(1);
    }

    75% {
      transform: scale(1.05);
    }
  }
}
</style>
